import React from 'react';
import { ModernHeader } from '../components/ModernHeader';
import { Hero } from '../components/Hero';
import { CategoryDirectory } from '../components/CategoryDirectory';
import { AuthoritySection } from '../components/AuthoritySection';
import { B2BSection } from '../components/B2BSection';
import { BrandSection } from '../components/BrandSection';
import { SeoDescriptionSection } from '../components/SeoDescriptionSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white" data-id="element-692">
      <ModernHeader data-id="element-693" />
      <Hero data-id="element-694" />
      <CategoryDirectory data-id="element-695" />
      <AuthoritySection data-id="element-696" />
      <B2BSection data-id="element-697" />
      <SeoDescriptionSection data-id="element-698" />
      <BrandSection data-id="element-699" />
      <Footer data-id="element-700" />
    </div>;
}